import { useGetTreeById } from 'shared/hooks/trees/hooks'
import React, { useMemo } from 'react'
import { createIdMap } from '../../../version_mapping/utility'
import { Box } from '@mui/material'
import { InfoDisplay } from '../../../utility/Containers'
import { FilteredTreeTable } from '../FilteredTreeTable'
import { duplicatePointsLeafFilter } from '../filters'
import { LeafTypes } from 'shared/types/ingestion'

export function DuplicatePointsCleanup({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })

  const idMap = useMemo(() => {
    return tree && createIdMap(tree)
  }, [tree])

  return (
    <Box>
      <InfoDisplay>
        <Box>Duplicate Points Leaves</Box>
        <Box>
          The results shown in this table are points leaves that have a sibling
          points leaf. The first points leaf is not included in this set.
        </Box>
      </InfoDisplay>
      <FilteredTreeTable
        filter={duplicatePointsLeafFilter}
        treeId={treeId}
        versionId={versionId}
        action={{ actionType: 'delete' }}
        customColumns={[
          {
            title: 'ParentID',
            rowContent(item) {
              return item.parent_id
            },
          },
          {
            title: 'LeafID',
            rowContent(item) {
              return item.id
            },
          },
          {
            title: 'Keeping',
            rowContent(item) {
              const parent = idMap?.[item.parent_id ?? '']?.node
              const sibling = parent?.leaves?.find(
                ({ type }) => type === LeafTypes.Points,
              )
              return sibling?.id
            },
          },
        ]}
      />
    </Box>
  )
}
